import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-why-chooes',
  templateUrl: './why-chooes.component.html',
  styleUrls: ['./why-chooes.component.scss']
})
export class WhyChooesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
